import React, { Fragment, useEffect } from 'react';
import { Box, Card, Flex, Heading, Text } from 'rebass/styled-components';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Header from '../components/Header';
import withAnalytics from '../lib/withAnalytics';
import FullLayout2 from '../components/FullLayout';
import { CleanDom } from '../utils/domCleanup';

const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto !important;
`;

const CardContainer = styled(Flex)`
  max-width: 400px;
`;

const AccountLocked: React.FC<{ analytics: any }> = ({ analytics }) => {
  const { state } = useLocation()

  useEffect(() => {
    analytics.page();
    CleanDom()
    // if (!id) {
    //   navigate('/login')
    // }
  }, [])

  return (
    <FullLayout2 style={{ overflow: 'auto', zIndex: 10 }}>
      <Fragment>
        <Container>
          <Flex flex={1} flexDirection="column">
            <Header dark={false} childContainerStyle={{ marginTop: '-16px' }}>
              <Heading sx={{ marginLeft: '97px' }}>Health Coaches</Heading>
            </Header>
          </Flex>
          <Flex flex={1} alignItems="center" justifyContent="center">
            <CardContainer flex={1} px={3}>
              <Card p={4}>
                <Flex flexDirection="column">
                  <Box mb={4}>
                    <Heading textAlign="center" mb={3}>
                      Security Information
                    </Heading>
                  </Box>
                  <Fragment>
                  <Text textAlign="center">
                      Your account has been locked for security purposes:
                      <br />
                      <br />
                      <span
                        style={{ color: 'rgb(237, 183, 168)', fontWeight: 700 }}
                      >
                        5 incorrect password attempts
                      </span>
                    </Text>
                    <Text textAlign="center" mt={4}>
                      An email has been sent to {(state as any).email} with instructions to
                      unlock your account.
                    </Text>
                    <Text textAlign="center" mt={2}>
                      If you did not receive it, you can request another email
                      below.
                    </Text>
                    <Text textAlign="center" mt={2}>
                      Please allow 5 minutes for the email to reach your
                      mailbox.
                    </Text>
                  </Fragment>
                </Flex>
              </Card>
            </CardContainer>
          </Flex>
        </Container>
      </Fragment>
    </FullLayout2>
  );
};

// export default withAnalytics(withToastManager(Login));
export default withAnalytics(AccountLocked);
